var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"min-vh-100",attrs:{"id":"app"}},[(_vm.errorObject.errorPopupIsShow)?_c('error-popup'):_vm._e(),(_vm.isLoading)?_c('loading-popup'):_vm._e(),_c('router-view'),(
      _vm.routeName == 'home' || _vm.routeName == 'about' || _vm.routeName == 'expired'
    )?_c('app-footer',{attrs:{"withBackground":_vm.routeName == 'home',"isExpired":_vm.routeName == 'expired'}}):_vm._e()],1)
}
var staticRenderFns = []

export { render, staticRenderFns }